import React from 'react'
import { Card, ListGroup, Badge } from 'react-bootstrap'
import { IconButton } from '@material-ui/core'
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer'
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos'
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos'

export default function PedidosVigentesConsulta ({ cpa, pedidos }) {
  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false
  })

  const anchor = 'right'

  const toggleDrawer = (anchor, open) => (event) => {
    if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return
    }
    setState({ ...state, [anchor]: open })
  }

  return (
    <div>
      <IconButton style={{ outline: 'none' }} onClick={toggleDrawer(anchor, true)}><ArrowBackIosIcon style={{ fontSize: '1.3rem' }} /> Ver Pedidos vigentes de calado</IconButton>
      <SwipeableDrawer
        anchor={anchor}
        open={state[anchor]}
        className='drawer-pedidos-vigentes'
        onClose={toggleDrawer(anchor, false)}
        onOpen={toggleDrawer(anchor, true)}
      >
        <Card className='card-pedidos-camiones'>
          <IconButton style={{ outline: 'none', justifyContent: 'flex-end' }} onClick={toggleDrawer(anchor, false)}><ArrowForwardIosIcon /></IconButton>
          <h6 className='titulo-pedidos-consulta' style={{ margin: '5% auto 2% auto', fontSize: '1.3rem' }}>Pedidos vigentes desde calado</h6>
          <div className='container-pedidos-camiones'>
            {pedidos && pedidos.map((pedido) => (
              <div key={pedido.cereal}>
                <ListGroup vertical='true'>
                  {(pedido.cereal === cpa.claveCereal) && <ListGroup.Item className='item-list-pedidos' style={{ backgroundColor: '#707070', color: '#ffffff' }}>
                    <strong>{pedido.cereal}</strong>
                    <Badge pill style={{ backgroundColor: '#ffffff', color: '#707070', fontSize: '0.9rem', margin: '0 2%' }}>{pedido.restantes}</Badge>
                  </ListGroup.Item>}
                  {(pedido.cereal !== cpa.claveCereal) && <ListGroup.Item className='item-list-pedidos' style={{ backgroundColor: 'rgb(155 155 155)', color: '#ffffff' }}>
                    <strong>{pedido.cereal}</strong>
                    <Badge pill style={{ backgroundColor: '#ffffff', color: 'rgb(155 155 155)', fontSize: '0.9rem', margin: '0 2%' }}>{pedido.restantes}</Badge>
                  </ListGroup.Item>}
                </ListGroup>
              </div>
            ))
            }
          </div>
        </Card>
      </SwipeableDrawer>
    </div>
  )
}
